/*! @azure/msal-browser v2.38.2 2023-08-24 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.38.2";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
